import { BANK_FOOTAGE_UUIDS_MAX } from 'fym-shared/src/music24/musicVideoApi';
import type { MusicVideoDoc } from 'fym-shared/src/music24/musicVideoDoc';

/** The uuids of the bank clips that a cut uses, each once, in a fixed order. Pure. */
export function bankUuidsOfDoc(doc: Pick<MusicVideoDoc, 'clips'>): string[] {
  const uuids = new Set<string>();
  doc.clips.forEach((clip) => {
    if (clip.source.kind === 'bank') {
      uuids.add(clip.source.clipUuid);
    }
  });
  return [...uuids].sort();
}

/** The uuids in requests of at most `BANK_FOOTAGE_UUIDS_MAX` (the limit of `GET /footage/bank?uuids=`). Pure. */
export function bankUuidChunks(uuids: readonly string[], size: number = BANK_FOOTAGE_UUIDS_MAX): string[][] {
  const chunks: string[][] = [];
  for (let start = 0; start < uuids.length; start += size) {
    chunks.push(uuids.slice(start, start + size));
  }
  return chunks;
}

/** The uuids that are not loaded and not asked for yet. Pure. */
export function missingBankUuids(
  uuids: readonly string[],
  known: ReadonlySet<string>,
  requested: ReadonlySet<string>
): string[] {
  return uuids.filter((uuid) => !known.has(uuid) && !requested.has(uuid));
}
